
import u from "umbrellajs"
import _once from "lodash/once"

// # Assumed one element only
const getSectionJQueryElement = _once(() => u("#layout-section--mobile-searcher-app-smart-banner"))


// # See `app/assets/stylesheets/components/layout/sections/mobile_searcher_app_smart_banner/all.scss`
const SHOWN_STATE_CLASS_NAME = "layout-section--mobile-searcher-app-smart-banner--shown"

const hide = () => {
  getSectionJQueryElement().removeClass(SHOWN_STATE_CLASS_NAME)
}

export default {
  hide,
}
